import React, { useState, useEffect } from "react";
import DataTable from "react-data-table-component";
import Loading from "../components/Loading";
import { post } from "./api";

const customStyles = {
  tableWrapper: {
    style: {
      borderTopLeftRadius: "14px",
      borderTopRightRadius: "14px",
      overflow: "hidden",
      textAlign: "start",
    },
  },
  headRow: {
    style: {
      backgroundColor: "rgb(255, 255, 255)",
      color: "rgba(76, 120, 137, 1)",
      fontWeight: "500",
      fontSize: "16px",
      borderBottom: "1px solid rgb(159, 156, 156)",
      borderTop: "none",
      padding: "15px 10px",
    },
  },
  rows: {
    style: {
      fontWeight: "400",
      fontSize: "15px",
      color: "rgba(119, 125, 130, 1)",
      backgroundColor: "rgb(255, 255, 255)",
      minHeight: "48px",
      padding: "20px 10px",
    },
    highlightOnHoverStyle: {
      color: "rgb(63, 65, 67)",
      backgroundColor: "rgba(224, 233, 237, 1)",
      transitionDuration: "0.15s",
      transitionProperty: "background-color",
      outlineStyle: "solid",
      outlineWidth: "1px",
    },
  },

  pagination: {
    style: {
      borderTop: "none",
    },
  },
};
const TMSDataTablePagination = React.memo(
  ({ columns, apiUrl, queryObj, isRoute }) => {
    //updateState = false
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [perPage, setPerPage] = useState(10);
    const [totalRows, setTotalRows] = useState();
    const [showPagination, setShowPagination] = useState(true);
    const query = queryObj;

    const fetchUsers = async (page, perPage, query) => {
      setLoading(true);
      if (apiUrl != "") {
        try {
          const response = await post(`${apiUrl}`, {
            ...(query.search ? { search: query.search } : {}),
            options: {
              page: page,
              limit: perPage,
            },
            ...(isRoute ? { search: query } : { query: query }),
          });
          if (response?.data?.docs) {
            setData(response.data.docs);
            setTotalRows(response.meta.total);
            setShowPagination(response.meta.total > perPage);
          } else {
            setData(response.data);
            setShowPagination(false);
          }
          setLoading(false);
        } catch (error) {
          console.error("Error fetching data:", error);
          setLoading(false);
        }
      }
    };

    const handlePageChange = (page) => {
      fetchUsers(page, perPage, query);
    };

    const handlePerRowsChange = async (newPerPage) => {
      setPerPage(newPerPage);
      fetchUsers(1, newPerPage, query);
    };

    useEffect(() => {
      fetchUsers(1, perPage, queryObj);
    }, [queryObj, perPage]);
    // updateState
    return (
      <DataTable
        columns={columns}
        data={data}
        progressPending={loading}
        progressComponent={<Loading />}
        persistTableHead
        pagination={showPagination}
        paginationServer
        paginationPerPage={perPage}
        paginationRowsPerPageOptions={[10, 20, 30]}
        paginationTotalRows={totalRows}
        onChangeRowsPerPage={handlePerRowsChange}
        onChangePage={handlePageChange}
        customStyles={customStyles}
        highlightOnHover
        noDataComponent={<p className="pt-3 pb-2">Records not found</p>}
      />
    );
  }
);

TMSDataTablePagination.displayName = "TMSDataTablePagination";
export default TMSDataTablePagination;
